import MobileMenu from "./MobileMenu";

export default class BigMenu {
    private $menuwrap: JQuery = null;
    private $menu: JQuery = null;
    private $letters: JQuery = null;

    private querytimer = null;

    public close(): void {
        this.$menu.removeClass('opened');
        $('body').removeClass('body--lock');
    }

    public toggle(): void {
        this.$menu.toggleClass('opened');
        $('body').toggleClass('body--lock');
    }

    private updateLayout(): void {
        $('.bigmenu__letter-head > *', this.$menu).unwrap();

        const $groups = $('.bigmenu__letter-group', this.$menu);

        $groups.each((ix, el) => {
            const $group = $(el);

            let $head = $('.bigmenu__letter', $group).add($('.bigmenu__item:visible:first', $group));

            $head.wrapAll('<div class="bigmenu__letter-head">');
        });
    }

    public setQuery(query?: string): void {
        const $items = $('.bigmenu__item', this.$menu);
        const $groups = $('.bigmenu__letter-group', this.$menu);

        query = query !== null ? query.trim() : null;

        const letter = query && query.length == 1 ? query.substr(0, 1).toUpperCase() : null;

        const showall = query === null || query.length == 0;
        const lquery = query !== null ? query.toLowerCase() : null;

        $items.each((ix, el) => {
            const $item = $(el);
            const text = $item.text().trim().toLowerCase();

            const pos = text.indexOf(lquery);
            const found = showall || query.length == 1 ? pos == 0 : pos >= 0;

            $item.toggleClass('bigmenu__item--found', found);

            if (found) {
                $item.show();
            } else {
                $item.hide();
            }
        });

        $groups.each((ix, el) => {
            const $group = $(el);

            const found = $('.bigmenu__item--found', $group).length;

            if (found) {
                $group.show();
            } else {
                $group.hide();
            }
        });

        const $products = $('.bigmenu__products-results', this.$menu);

        if (this.querytimer != null) {
            clearTimeout(this.querytimer);
            this.querytimer = null;
        }

        if (letter != null) {
            this.$letters.each((ix, el) => {
                const $li = $(el);
                const l: string = $li.data('letter');

                $li.toggleClass('bigmenu__letters--selected', l == letter);
            });
        } else {
            this.$letters.removeClass('bigmenu__letters--selected');
        }

        if (query && query.length > 1) {
            this.querytimer = setTimeout(() => {
                $.ajax({
                    url: '/bigmenu/query',
                    data: {
                        query: query
                    },

                    success: (r) => {
                        $products.html(r);
                    },
                });
            }, 300);
        } else {
            $products.html('');
        }

        this.updateLayout();
    }

    private initBigMenu(): void {
        this.$menu = $('.bigmenu', this.$menuwrap);

        const $close = $('.bigmenu__close', this.$menu);
        const $menu = $('.menu', this.$menu);
        this.$letters = $('.bigmenu__letters li', this.$menu);

        new (<any> window).BluMenu($menu, {
            events: false,
        });

        (<any> window).Site.discover(this.$menu);

        $('.menu__item--children > .menu__head', $menu).each((ix, el) => {
            const $item = $(el).parent();
            const $sub = $('> .menu__list', $item);

            $item.on('click', (e) => {
                if (!$sub.is(':visible')) {
                    e.preventDefault();

                    $item.addClass('menu__item--opened');
                    $sub.slideDown();
                }
            });
        });

        $close.on('click', (e) => {
            this.close();
        });

        const $search = $('.bigmenu__search');
        const $isearch = $('input[name="q"]', $search);

        $isearch.on('keyup', (e) => {
            this.setQuery($isearch.val());
        });

        this.updateLayout();

        this.$menu.on('mouseleave', (e) => {
            this.close();
        });

        let outtimer = null;

        this.$letters.each((ix, el) => {
            const $li = $(el);
            const $btn = $('button', $li);
            const letter = $btn.text().toUpperCase();

            $li.data('letter', letter);

            $btn.on('click', (e) => {
                if ($isearch.val() == letter) {
                    $isearch.val('');
                    this.setQuery('');
                } else {
                    $isearch.val(letter);
                    this.setQuery(letter);
                }
            });

            $btn.on('mouseenter', () => {
                $isearch.val(letter);
                this.setQuery(letter);

                if (outtimer) {
                    clearTimeout(outtimer);
                    outtimer = null;
                }
            });

            $btn.on('mouseout', () => {
                if (outtimer) {
                    clearTimeout(outtimer);
                    outtimer = null;
                }

                outtimer = setTimeout(() => {
                    // this.setQuery($isearch.val());
                }, 200);
            });
        });
    }

    public initHtml() {
        const $button = $('.header__bigmenu button');

        $button.on('click', (e) => {
            if (this.$menuwrap == null) {
                this.$menuwrap = $(`<div class="bigmenu-wrapper">`);

                $.ajax({
                    url: '/bigmenu',
                    method: 'get',

                    success: (r) => {
                        this.$menuwrap.html(r);

                        this.initBigMenu();

                        this.$menu[0].offsetHeight;

                        this.toggle();
                    },
                })

                $('body').append(this.$menuwrap);
            } else {
                this.toggle();
            }
        });
    }

    public static initMenus(): void {
        const ismobile = window.innerWidth <= 768;

        if (ismobile) {
            const mm = new MobileMenu();
            mm.initHtml();
        } else {
            const bm = new BigMenu();
            bm.initHtml();
        }
    }
}
